import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b81de922&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=b81de922&prod&lang=css&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=b81de922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81de922",
  null
  
)

export default component.exports